(() => {
  if (window.paKlaviyoCartTracking) return;
  window.paKlaviyoCartTracking = true;
  const identity = item => JSON.stringify([item.variant_id || item.id, item.selling_plan_allocation?.selling_plan?.id || null, Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b))]);
  const quantities = items => {
    const result = new Map();
    for (const item of items) { const key = identity(item); result.set(key, (result.get(key) || 0) + item.quantity); }
    return result;
  };
  let previous;
  try { previous = quantities(JSON.parse(document.getElementById('pa-klaviyo-cart-baseline').textContent)); }
  catch { return; } // Fail closed if the initial cart cannot be reconciled.
  const absolute = url => url ? new URL(url, location.origin).href : '';
  document.addEventListener('cart:change', event => {
    const cart = event.detail?.cart;
    if (!Array.isArray(cart?.items)) return;
    const next = quantities(cart.items), increases = [];
    const seen = new Set();
    for (const item of cart.items) {
      const key = identity(item), quantity = next.get(key) - (previous.get(key) || 0);
      if (quantity > 0 && !seen.has(key)) increases.push({item, quantity});
      seen.add(key);
    }
    previous = next; // Also advance on decreases, duplicates and denied consent; never replay them later.
    if (!['variant:add', 'line-item:change'].includes(event.detail.baseEvent)) return;
    if (!increases.length) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.marketingAllowed?.() || !privacy?.analyticsProcessingAllowed?.()) return;
    const klaviyo = window.klaviyo || (window.klaviyo = []);
    const items = cart.items.map(item => ({
      ProductID: item.product_id, VariantID: item.variant_id || item.id, SKU: item.sku || '',
      ProductName: item.product_title, Quantity: item.quantity,
      ItemPrice: item.final_price / 100, RowTotal: item.final_line_price / 100,
      ProductURL: absolute(item.url), ImageURL: absolute(item.image || item.featured_image?.url)
    }));
    // A cart permalink preserves the product variants/quantities for an emailed return journey.
    const checkout = new URL((window.Shopify?.routes?.root || '/') + 'cart/' + cart.items.map(item => `${item.variant_id || item.id}:${item.quantity}`).join(','), location.origin);
    for (const {item, quantity} of increases) {
      klaviyo.push(['track', 'Added to Cart', {
        $value: cart.total_price / 100, Currency: cart.currency,
        AddedItemProductName: item.product_title, AddedItemProductID: item.product_id,
        AddedItemSKU: item.sku || '', AddedItemPrice: item.final_price / 100,
        AddedItemQuantity: quantity, AddedItemImageURL: absolute(item.image || item.featured_image?.url),
        AddedItemURL: absolute(item.url), ItemNames: cart.items.map(row => row.product_title),
        CheckoutURL: checkout.href, Items: items
      }]);
    }
  });
})();
